import { SALES_STATUS_ON_SALE } from '../../../../../../organizer/event-sidenav/src/constants';
import { ConversionBarContainerProps } from './ConversionBarContainer';

type CompactCheckoutFlags =
    ConversionBarContainerProps['compactCheckoutDisqualifications'];

export type CondensedCheckoutExclusionProps = {
    soldOut: CompactCheckoutFlags['sold_out'];
    isSalesEnded: CompactCheckoutFlags['is_sales_ended'];
    isPostponed: CompactCheckoutFlags['is_postponed'];
    isCanceled: CompactCheckoutFlags['is_canceled'];
    hasWaitlist: CompactCheckoutFlags['has_waitlist'];
    isRsvp: CompactCheckoutFlags['is_rsvp'];
    salesStatus: ConversionBarContainerProps['salesStatus'];
    showExtraPriceInformation?: boolean;
};

export const isCondensedCheckoutExcluded = (
    props: CondensedCheckoutExclusionProps,
): boolean => {
    if (props.salesStatus !== SALES_STATUS_ON_SALE) {
        return true;
    }

    const exclusionConditions = [
        props.soldOut,
        props.isSalesEnded,
        props.isPostponed,
        props.isCanceled,
        props.hasWaitlist,
        props.isRsvp,
        props.showExtraPriceInformation,
    ];

    return exclusionConditions.some(Boolean);
};
